import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { MantineProvider } from "@mantine/core";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import { App } from "./App";
import { theme } from "./theme";
import { ErrorBoundary } from "./maintenance/ErrorBoundary";
import { MaintenanceOverlay } from "./maintenance/MaintenanceOverlay";
import { SetPasswordScreen, parseSetPasswordUrl } from "./components/SetPasswordScreen";
import { BadgesProvider } from "./hooks/BadgesContext";

// US-65: pre-route check ДО роутера. /app/set-password/<uidb64>/<token>/ —
// отдельная страница БЕЗ авторизации (там как раз пароль устанавливают);
// держим её вне BadgesProvider, чтобы анонимный пользователь не ловил
// 401-polling бейджей. Всё остальное — App внутри BrowserRouter (US-90).
const setPwParams = parseSetPasswordUrl(window.location.pathname);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <ErrorBoundary>
        {setPwParams ? (
          <SetPasswordScreen uidb64={setPwParams.uidb64} token={setPwParams.token} />
        ) : (
          // US-59 #8: BadgesProvider — один общий источник counters для всего
          // дерева. Любой компонент может позвать useBadges().refresh() сразу
          // после успешного submit / approve / return / login, не дожидаясь
          // 30-секундного polling-тика.
          <BadgesProvider>
            {/* US-90: все пути SPA живут под /app/ — basename, чтобы внутри
                роутов писать просто /timesheet, /approvals и т.д. */}
            <BrowserRouter basename="/app">
              <App />
            </BrowserRouter>
          </BadgesProvider>
        )}
      </ErrorBoundary>
      {/* Overlay рендерится вне ErrorBoundary — должен показываться даже когда
          дерево App упало (US-56). */}
      <MaintenanceOverlay />
    </MantineProvider>
  </React.StrictMode>,
);
